module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "drcell",
    attrs: {
      "href": _vm.href
    }
  }, [(_vm.isLink) ? _c('span', {
    staticClass: "dr-cell-mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dr-cell-left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "dr-cell-wrapper"
  }, [_c('div', {
    staticClass: "dr-cell-title"
  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "mintui",
    class: 'mintui-' + _vm.icon
  }) : _vm._e()]), _vm._v(" "), _vm._t("title", [_c('div', {
    staticClass: "dr-cell-contain"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('span', {
    staticClass: "dr-cell-text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dr-cell-rating",
    domProps: {
      "textContent": _vm._s(_vm.rate)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dr-cell-rating-u"
  }, [_vm._v("分")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('span', {
    staticClass: "dr-cell-label",
    domProps: {
      "textContent": _vm._s(_vm.movieTags)
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('span', {
    staticClass: "dr-cell-label1",
    domProps: {
      "textContent": _vm._s('主演：' + _vm.movieCatas)
    }
  })])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dr-cell-right"
  }, [_vm._t("right")], 2), _vm._v(" "), _c('div', {
    staticClass: "dr-cell-line"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e843068!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/cell/cell.vue
// module id = 88
// module chunks = 2